<template>
  <div class="prices" id="prices">
    <h2>{{ pricing.pricingTitle }}</h2>

    <div class="prices__flex">
      <Tile v-for="(tile, index) in mainTiles" :key="index" v-bind="tile" />
    </div>

    <button class="prices__button" @click="isExpanded = !isExpanded">
      <p>{{ isExpanded ? pricing.seeLessButton : pricing.seeMoreButton }}</p>
    </button>

    <div v-if="isExpanded" class="prices-expanded">
      <p>
        {{ pricing.pricingTextOne }}
      </p>
      <br />
      <p>
        {{ pricing.pricingTextTwo }}
      </p>

      <h3>{{ pricing.pricingSubtitleOne }}</h3>

      <div class="prices__flex">
        <Tile v-for="(tile, index) in dessertTiles" :key="index" v-bind="tile" />
      </div>

      <h3>{{ pricing.pricingSubtitleTwo }}</h3>

      <div class="prices__flex">
        <Tile v-for="(tile, index) in extraTiles" :key="index" v-bind="tile" />
      </div>

      <p>
        {{ pricing.pricingTextThree }}
      </p>

      <br />

      <p>
        {{ pricing.pricingTextFour }}
      </p>

      <br />

      <p>
        {{ pricing.pricingTextFive }}
      </p>

      <!-- <h3>{{ pricing.pricingSubtitleThree }}</h3> -->

      <div class="prices__flex prices__margin">
        <!-- <Tile v-for="(tile, index) in deliveryTiles" :key="index" v-bind="tile" /> -->
      </div>
    </div>
  </div>
</template>

<script>
import Tile from "@/components/Tile.vue";

const MAIN = ["One", "Two", "Three"];
const DESSERT = ["Four", "Five"];
const EXTRA = ["Six", "Seven"];
const DELIVERY = ["Nine", "Ten", "Eleven"];

export default {
  components: {
    Tile,
  },
  props: {
    pricing: Object,
  },
  data() {
    return {
      isExpanded: false,
    };
  },
  computed: {
    mainTiles() {
      return MAIN.map((ordinal, index) => ({
        ...this.tile(ordinal),
        number: this.pricing[`pricingTile${ordinal}Title`],
        text: this.pricing[`pricingTile${ordinal}Subtitle`],
        highlight: index === 1,
        pricingTileCallout: this.pricing.pricingTileCallout,
      }));
    },
    dessertTiles() {
      return DESSERT.map(this.tile);
    },
    extraTiles() {
      return EXTRA.map(this.tile);
    },
    deliveryTiles() {
      return DELIVERY.map(this.tile);
    },
  },
  methods: {
    tile(ordinal) {
      return {
        text: this.pricing[`pricingTile${ordinal}Title`],
        price: this.pricing[`pricingTile${ordinal}Price`],
        callout: this.pricing[`pricingTile${ordinal}Description`],
      };
    },
  },
};
</script>

<style lang="scss">
.prices {
  max-width: 850px;
  margin: auto;
  padding-top: 7.5rem;
  margin-top: -2.5rem;

  @media (max-width: $tablet) {
    padding: 0rem 1.18rem;
    padding-top: 7.5rem;
    margin-top: -2.5rem;
  }

  h2 {
    text-align: center;
    margin-bottom: 2.5rem;
  }

  &__flex {
    display: flex;
    justify-content: start;
    gap: 2.5rem;
    margin-bottom: 1.5rem;

    @media (max-width: $tablet) {
      gap: 1rem;
    }

    @media (max-width: 870px) {
      flex-direction: column;
      align-items: center;
    }
  }

  &__button {
    display: block;
    margin: auto;
    margin-top: 3rem;
    margin-bottom: 3rem;
    cursor: pointer;

    p {
      font-weight: 600;
      text-decoration: underline;
      font-size: 1.25rem;
    }
  }

  &__margin {
    margin-bottom: 4rem !important;
  }
}

.prices-expanded {
  & > p,
  h3 {
    text-align: start;
  }

  h3 {
    margin-top: 3rem;
    margin-bottom: 1rem;
  }
}
</style>
